/**
 * Header carrying the client's session id for the single-active-session policy.
 *
 * Lives in its own module because both sides need it: the client middleware in
 * `start.ts` sets it, the server middleware reads it. Importing it straight from
 * `active-session-middleware.ts` would pull that module's server-only chain
 * (Supabase client, react-start/server) into the start entry graph of every
 * environment — and made both entry graphs share a node that the dev server
 * loads concurrently.
 */
export const XENO_SESSION_HEADER = "x-xeno-session";
